import { gql } from '@apollo/client'

export const GET_EMPLOYEE_RETURN_CASES = gql`
  query getEmployeeReturnCases($id: ID!) {
    employee(id: $id) {
      id
      returnCases {
        __typename
        totalCount
        pageInfo {
          __typename
          endCursor
          hasNextPage
        }
        returnCases {
          id
          employee {
            id
            contact {
              id
              firstName
              lastName
            }
          }
          createdAt
          stocklistItem {
            id
            deviceDefinition {
              id
              codename
              imageURL
              manufacturer
              name
              productType
            }
          }
          portalStatus
        }
      }
    }
  }
`
